import { useParams, useNavigate } from 'react-router-dom';
import { blogPosts } from './blogData';
import './Blog.css';

export default function BlogDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const post = blogPosts.find(p => p.slug === slug);

  if (!post) return (
    <div className="blog-not-found">
      <h2>Blog post not found</h2>
      <button onClick={() => navigate('/blog')}>← Back to Blog</button>
    </div>
  );

  return (
    <div className="blog-detail">
      <div className="blog-detail-hero" style={{ backgroundImage: `url(${post.image})` }}>
        <div className="blog-detail-hero-overlay">
          <h1>{post.title}</h1>
        </div>
      </div>

      <div className="container blog-detail-body">
        <div className="blog-detail-meta">
          <span className="blog-category">{post.category}</span>
          <span className="blog-date">📅 {post.date}</span>
        </div>

        <div className="blog-detail-description">
          <h3>Description</h3>
          <p>{post.excerpt.replace('...', '')}</p>
        </div>

        <div
          className="blog-detail-content"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />

        <button className="blog-back-btn" onClick={() => navigate('/blog')}>
          ← Back to Blog
        </button>
      </div>
    </div>
  );
}
